import { ReactNode } from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { AnimatePresence, motion } from "framer-motion";

interface SheetProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  className?: string;
}

export const Sheet = ({ isOpen, onClose, title, children, className = "" }: SheetProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <Dialog static open={isOpen} onClose={onClose} className="relative z-50">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.26 }}
            className="fixed inset-0 bg-scrim"
            aria-hidden="true"
          />
          <div className="fixed inset-x-0 bottom-0 flex justify-center">
            <DialogPanel className="w-full max-w-overlay">
              <motion.div
                initial={{ y: "100%" }}
                animate={{ y: 0 }}
                exit={{ y: "100%" }}
                transition={{ duration: 0.26, ease: [0.2, 0.7, 0.2, 1] }}
                className={`glass-modal max-h-sheet overflow-y-auto scrollbar-none px-3 pt-2.25 pb-3 rounded-t-sheet bg-surface-content shadow-sheet ${className}`}
              >
                <span className="block w-handle-w h-handle-h mx-auto mb-2.5 rounded-pill bg-line-handle" />
                {title && (
                  <DialogTitle className="font-ui text-control-sm font-800 tracking-tight text-ink">
                    {title}
                  </DialogTitle>
                )}
                {children}
              </motion.div>
            </DialogPanel>
          </div>
        </Dialog>
      )}
    </AnimatePresence>
  );
};